import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styles from "./Courses.module.css";

export default function Courses() {
  const { user } = useContext(AuthContext);

  const [allCourses, setAllCourses] = useState([]);
  const [myCourses, setMyCourses] = useState([]);

  useEffect(() => {
    if (!user) return;
    fetch(`${process.env.REACT_APP_API_URL}/api/catalog`, {
      credentials: 'include'
    })
      .then(r => r.json())
      .then(data => {
        setAllCourses(Array.isArray(data) ? data : []);
      })
      .catch(err => {
        console.error('Error cargando catálogo:', err);
        setAllCourses([]);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/courses`, {
      credentials: 'include'
    })
      .then(r => r.json())
      .then(data => {
        setMyCourses(Array.isArray(data) ? data : []);
      })
      .catch(err => {
        console.error('Error cargando mis cursos:', err);
        setMyCourses([]);
      });
  }, [user]);


  const enrolledIds = new Set(myCourses.map(c => String(c.id)));
  const available = Array.isArray(allCourses)
    ? allCourses.filter(c => !enrolledIds.has(String(c.id)))
    : [];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Bienvenido a Medicina Total</h1>
        <p>
          Explora y accede a todos nuestros cursos de medicina, o continúa donde
          lo dejaste.
        </p>
      </div>

      <section className={styles.section}>
        <h2 className={styles.title}>Cursos Disponibles</h2>
        <p className={styles.subtitle}>
          {available.length
            ? "Estos cursos podrían interesarte:"
            : "Ya estás inscrito en todos los cursos."}
        </p>
        <div className={styles.grid}>
          {available.map(c => (
            <Link key={c.id} to={`/courses/${c.id}`} className={styles.card}>
              <img
                src={c.imageUrl}
                alt={c.title}
                className={styles.cardImg}
              />
              <div className={styles.cardContent}>
                <h3>{c.title}</h3>
                <p>{c.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.title}>Mis Cursos</h2>
        <p className={styles.subtitle}>
          {myCourses.length
            ? "Continúa aprendiendo:"
            : "Aún no estás inscrito en ningún curso."}
        </p>
        <div className={styles.grid}>
          {myCourses.map(c => (
            <Link key={c.id} to={`/courses/${c.id}`} className={styles.card}>
              <img
                src={c.imageUrl}
                alt={c.title}
                className={styles.cardImg}
              />
              <div className={styles.cardContent}>
                <h3>{c.title}</h3>
                <p>{c.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
